import BaseForm from "./Formlib/BaseForm";
import BaseItem from "./Formlib/BaseItem";
import ViewPage from "./ViewPage";
import Title from "./Title";

export default {
  install(Vue) {
    Vue.component(BaseForm.name, BaseForm);
    Vue.component(BaseItem.name, BaseItem);
    Vue.component(ViewPage.name, ViewPage);
    Vue.component(Title.name, Title);
  },
};
